var map = {
  "./cs.json": [
    "pL",
    [
      "z4o"
    ]
  ],
  "./en.json": [
    "VCE",
    [
      "7qg"
    ]
  ],
  "./pl.json": [
    "wX",
    [
      "mxl"
    ]
  ],
  "./ru.json": [
    "KUCA",
    [
      "o9"
    ]
  ],
  "./tr.json": [
    "tX",
    [
      "f2y"
    ]
  ],
  "./ja.json": [
    "vvV",
    [
      "5b"
    ]
  ],
  "./zh.json": [
    "YGG",
    [
      "uxy"
    ]
  ],
  "./pt-br.json": [
    "QIr",
    [
      "i2"
    ]
  ],
  "./de.json": [
    "itE",
    [
      "si"
    ]
  ],
  "./es.json": [
    "BUx",
    [
      "3u"
    ]
  ],
  "./fr.json": [
    "ql",
    [
      "k8b"
    ]
  ],
  "./it.json": [
    "Nwt",
    [
      "39j"
    ]
  ],
  "./ko.json": [
    "nI",
    [
      "le"
    ]
  ],
  "./pt.json": [
    "ZBv",
    [
      "r7"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "cY";
module.exports = __rspack_async_context;
